import * as Yup from "yup";

export enum RoomHeader {
  add = "Add Room",
  edit = "Edit Room",
}

export const YesNo = ["Yes", "No"] as const;

export const RoomSchema = Yup.object({
  roomName: Yup.string().required("Required"),
  roomNumber: Yup.number().required("Required"),
  computerNumber: Yup.string().required("Required"),
  computerUserName: Yup.string().required("Required"),
  computerPassword: Yup.string().required("Required"),
  hasAppleTv: Yup.string()
    .oneOf([...YesNo])
    .defined("Required"),
  hasHdmi: Yup.string()
    .oneOf([...YesNo])
    .defined("Required"),
});

export type RoomFormType = Yup.TypeOf<typeof RoomSchema>;
export type RoomSubmitType = Yup.Asserts<typeof RoomSchema>;
